import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import PublicNavBar from '../../components/PublicNavBar';
import PortalFooter from '../../components/PortalFooter';
import { contentAPI } from '../../services/api';

const DEFAULT = `Callcenter-Suche
Musterstraße 123, 12345 Musterstadt
Telefon: +49 (0) 123 456789
E-Mail: info@callcenter-suche.de

Geschäftsführer: Max Mustermann

Handelsregister: Amtsgericht Musterstadt, HR-Nummer: 123456
Umsatzsteuer-ID: DE123456789

Haftungsausschluss: Die Inhalte unserer Website werden mit großer Sorgfalt erstellt. Wir übernehmen jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte.`;

const ImprintPage: React.FC = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    contentAPI.getAll()
      .then((res) => setContent(res.data.data?.content_imprint || DEFAULT))
      .catch(() => setContent(DEFAULT))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
      <PublicNavBar />
      <Container maxWidth="lg" sx={{ py: 6, flex: 1 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 4 }}>
          Impressum
        </Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 1.9 }}>
            {content}
          </Typography>
        )}
      </Container>
      <PortalFooter />
    </Box>
  );
};

export default ImprintPage;
